import {participantsGatewayInterface} from "../../../corelogic/usecases/participants/participantsGatewayInterface";
import {EParticipant} from "../../../corelogic/models/entities/participant/participant";
import {BillingDetail} from "../../../corelogic/models/entities/participant/billingDetail";
import {DsoDetails} from '../../../corelogic/models/entities/participant/dsoDetails';
import { BillableEntity } from "../../../corelogic/models/entities/billing-new/billableEntity";

export default class InMemoryParticipantsGateway implements participantsGatewayInterface {
    error: any;

    getParticipantsByJwt(): EParticipant[] | null {
        const dsoDetails1 = new DsoDetails("129381203891290", "129381203891290", "Grenoble", "38000", "hello", "Denis brognart")
        const dsoDetails2 = new DsoDetails("129381203891291", "", "Paris", "75000", "", "Participant2")
        const dsoDetails3 = new DsoDetails("129381203891292", "", "Lyon", "30000", "", "Participant3")
        const dsoDetails4 = new DsoDetails("129381203891293", "", "Toulouse", "31000", "", "Participant4")
        const dsoDetails5 = new DsoDetails("129381203891294", "", "Vinon", "83560", "", "Participant5")
        const dsoDetails6 = new DsoDetails("129381203891295", "", "Grenoble", "38000", "", "Participant6")

        const billingDetail = new BillingDetail(
            1,
            "toto",
            "1 court Berriat",
            "83560", "Valensole",
            "toto@email.com",
            "07 77 86 57 12",
            "1 billion euros"
        )
        const billableEntity = new BillableEntity(
            1,
            "Titi",
            "2 court Berriat",
            "38000",
            "Grenoble",
            "07 77 86 57 12",
            "titi@toto.com",
        )
        return [
            {
                _id: 1,
                _name: 'Denis Brogniart',
                _activationRange: [new Date(-8640000000000000), new Date(8640000000000000)],
                _userId: 1,
                _operationId: 1,
                _dsoDetails: dsoDetails1,
                _billingDetail: billingDetail,
                _billableEntity: billableEntity,
            },
            {
                _id: 2,
                _name: 'participant2',
                _activationRange: [new Date(-8640000000000000), new Date(8640000000000000)],
                _userId: 1,
                _operationId: 1,
                _dsoDetails: dsoDetails2,
                _billingDetail: billingDetail,
                _billableEntity: billableEntity,
            },
            {
                _id: 3,
                _name: 'participant3',
                _activationRange: [new Date(-8640000000000000), new Date(8640000000000000)],
                _userId: 1,
                _operationId: 1,
                _dsoDetails: dsoDetails3,
                _billingDetail: billingDetail,
                _billableEntity: billableEntity,
            },
            {
                _id: 4,
                _name: 'participant4',
                _activationRange: [new Date(-8640000000000000), new Date(8640000000000000)],
                _userId: 1,
                _operationId: 2,
                _dsoDetails: dsoDetails4,
                _billingDetail: billingDetail,
                _billableEntity: billableEntity,  
            },
            {
                _id: 5,
                _name: 'participant5',
                _activationRange: [new Date(-8640000000000000), new Date(8640000000000000)],
                _userId: 1,
                _operationId: 2,
                _dsoDetails: dsoDetails5,
                _billingDetail: billingDetail,
                _billableEntity: billableEntity,
            },
            {
                _id: 6,
                _name: 'participant6',
                _activationRange: [new Date(-8640000000000000), new Date(8640000000000000)],
                _userId: 1,
                _operationId: 2,
                _dsoDetails: dsoDetails6,
                _billingDetail: billingDetail,
                _billableEntity: billableEntity,
            },
        ];
    }

    updateDsoDetails({dsoDetails, participantId}: {
        dsoDetails: DsoDetails;
        participantId: number;
    }): Promise<DsoDetails> {
        return Promise.resolve(new DsoDetails("129381203891290", "129381203891290", "Grenoble", "38000", "", ""))
    }

    updateBillingDetail({
        billingDetail,
        participantId
    }: { billingDetail: BillingDetail; participantId: number }): Promise<BillingDetail> {
        return Promise.resolve(new BillingDetail(1, "toto", "1 court Berriat", "83560", "Valensole", "toto@email.com", "07 77 86 57 12", "1 billion euros"));
    }

    updateBillableEntity({
        billableEntity,
        participantId
    }: { billableEntity: BillableEntity; participantId: number }): Promise<BillableEntity> {
        return Promise.resolve(new BillableEntity(1, "Titi", "2 court Berriat", "38000", "Grenoble", "07 77 86 57 12", "titi@toto.com"));
    }
}
